import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";

import { BookingTypes, CabTypes, DestinationNames } from "../Constants";
import { devConsolelog } from "../Utility";

const BookingsFilters = (props) => {
  let { setBookingDateFilter, handleFilterChange, filters, bookingDateFilter } = props;
  devConsolelog("inside reqFilters ", {...filters})

  return (<Grid container columnSpacing={2} sx={{p:{md:2,xs:1}, background:"#fff"}}>
    {/* <Grid item md={3} xs={6} sx={{mt:{xs:2}}}>  
      <center>
        <ToggleButtonGroup
          color="primary"
          value={filters.bookingType}
          exclusive
          onChange={(e) => handleFilterChange("bookingType", e.target.value)}
          aria-label="Platform"
        >
          <ToggleButton value="cab">Cabs</ToggleButton>
          <ToggleButton value="fd">Fixed Departures</ToggleButton>
        </ToggleButtonGroup>
      </center>
    </Grid> */}

    <Grid item md={3} xs={6} sx={{mt:{xs:2}}}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <MobileDatePicker
          fullWidth
          label="Start Date*"
          onChange={(newValue) => {
            let formattedVal = +newValue; //Date.parse(new Date(newValue));
            handleFilterChange("startDate", formattedVal);
            // setBookingDateFilter(formattedVal);
          }}
          sx={{ width: "100%" }}
          closeOnSelect
          className={"date-picker-root"}
          renderInput={(params) => (
            <TextField
              fullWidth
              id="start-date"
              label="Start Date"
              variant="outlined"
              {...params}
            />
          )}
          value={filters?.startDate || null}
        />
      </LocalizationProvider>
    </Grid>
    <Grid item md={3} xs={6} sx={{mt:{xs:2}}}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <MobileDatePicker
          fullWidth
          label="End Date*"
          onChange={(newValue) => {
            let formattedVal = +newValue; //Date.parse(new Date(newValue));
            handleFilterChange("endDate", formattedVal);
            // setBookingDateFilter(formattedVal);
          }}
          sx={{ width: "100%" }}
          closeOnSelect
          className={"date-picker-root"}
          renderInput={(params) => (
            <TextField
              fullWidth
              id="end-date"
              label="End Date"
              variant="outlined"
              {...params}
            />
          )}
          value={filters?.endDate || null}
        />
      </LocalizationProvider>
    </Grid>

    <Grid item md={3} xs={6} sx={{mt:{xs:2}}}>
      <Autocomplete
        disablePortal
        id="booking-status-filter"
        includeInputInList
        onChange={(e, val) => handleFilterChange("bookingStatus", val)}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Booking status"
            variant="outlined"
          />
        )}
        options={BookingTypes}
        value={filters.bookingStatus}
        defaultValue={filters.bookingStatus}
      />
    </Grid>

    <Grid item md={3} xs={6} sx={{mt:{xs:2}}}>
      <Autocomplete
        disablePortal
        id="destination-filter"
        includeInputInList
        onChange={(e, val) => handleFilterChange("destination", val)}
        renderInput={(params) => (
          <TextField {...params} label="Destination" variant="outlined" />
        )}
        options={DestinationNames}
        value={filters.destination}
        defaultValue={filters.destination}
      />
    </Grid>

    <Grid item md={3} xs={6} sx={{mt:{xs:2}}}>
      <Autocomplete
        disablePortal
        id="cabType-filter"
        includeInputInList
        onChange={(e, val) => handleFilterChange("cabType", val)}
        renderInput={(params) => (
          <TextField {...params} label="Cab Type" variant="outlined" />
        )}
        options={CabTypes}
        value={filters.cabType}
        defaultValue={filters.cabType}
      />
    </Grid>

    <Grid item md={3} xs={6} sx={{mt:{xs:2}}}>
      <TextField label="Tracking Id" variant="outlined" sx={{width: '100%'}}
        onChange={(e) => handleFilterChange("trackingId", e.target.value)}
        value={filters?.trackingId || ""}
      />
    </Grid>

    <Grid item md={3} xs={6} sx={{mt:{xs:2}}}>
      <Button
        variant="outlined"
        size="small"
        sx={{
          marginTop: "10px"
        }}
        onClick={() => handleFilterChange(null, null, true)}
      >
        Clear All
      </Button>
    </Grid>

  </Grid>)
}

export default BookingsFilters;
